import { apiClient } from '../api/client';
import { useAuthStore } from '../store/authStore';
import { layerConfirm } from '../components/LayerPopup/LayerPopup';

/**
 * 로그아웃 — 확인 → 서버 세션 무효화 → 로컬 세션 정리.
 *
 * 옛 `MyProfilePage.handleLogout`(v2.14 · 2026-09-07 화면 삭제)과 **같은 절차**다. 프로필 팝오버(2026-08-12)가 두 번째
 * 진입점이 되면서 같은 코드가 두 벌이 되기 직전이라 여기로 뽑았다. 기존 화면은 건드리지
 * 않는다(회귀 금지) — 새 호출부만 이 함수를 쓴다.
 *
 * 서버 요청 실패는 삼킨다: 네트워크가 끊겨도 이 브라우저의 세션은 반드시 정리돼야 한다
 * (쿠키는 만료되고, 남는 건 화면 상태뿐이다). `clearSession` 이후 AuthGuard 가 /login 으로
 * 보내므로 별도 navigate 는 필요 없다.
 *
 * @param confirmMessage 확인 문구. 넘기지 않으면 확인 없이 즉시 로그아웃.
 * @returns 실제로 로그아웃했으면 true, 사용자가 취소했으면 false.
 */
export async function logout(confirmMessage?: string): Promise<boolean> {
  if (confirmMessage && !(await layerConfirm(confirmMessage))) return false;
  try {
    await apiClient.post('/auth/logout');
  } catch {
    /* best-effort — 네트워크 실패해도 로컬 세션은 정리한다. */
  }
  useAuthStore.getState().clearSession();
  return true;
}
